import { formatCurrency } from '@/common/utils/formatters'
import { Cluster } from '../../types/cluster'

interface StackedMarkerOptions {
  cluster?: Cluster
  showPrice?: boolean
  colorScheme?: 'dark' | 'light'
}

export const stackedMarker = ({ cluster, showPrice, colorScheme }: StackedMarkerOptions) => {
  const markerFill = colorScheme === 'dark' ? '#EAEAEA' : '#121212'
  const textFill = colorScheme === 'dark' ? '#121212' : '#EAEAEA'

  const productPrice = formatCurrency(Number(cluster?.product_price_value || 0))

  const rectPriceForMultiple = `
      <rect x="40" y="18" rx="16" ry="16" width="${62 + productPrice.length * 8.3}" height="32" fill="#1E1E1E" />
      <text x="66" y="38" text-anchor="left" font-size="12" fill="#9E9E9E" font-family="'Merriweather Sans', sans-serif" font-style="italic">Média</text>
      <text x="106" y="38" text-anchor="left" font-size="12" fill="white" font-family="'Merriweather Sans', sans-serif">${productPrice}</text>
    `

  const svg = `
    <svg width="${showPrice ? 240 : 51}" height="59" viewBox="0 0 68 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      ${showPrice ? rectPriceForMultiple : ''}
      <g filter="url(#filter0_f_21370_62911)">
        <ellipse cx="33.8828" cy="70.5" rx="7" ry="2.5" fill="black" fill-opacity="0.2" />
      </g>
      <g filter="url(#filter1_d_21370_62911)">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M33.88 6C48.7254 6 60.76 18.0346 60.76 32.88C60.76 44.2625 53.6851 53.9925 43.6929 57.9125L35.411 69.2328C35.2384 69.4698 35.0091 69.6632 34.7426 69.7968C34.4762 69.9303 34.1803 70 33.88 70C33.5797 70 33.2838 69.9303 33.0174 69.7968C32.7509 69.6632 32.5216 69.4698 32.349 69.2328L24.0671 57.9125C14.0749 53.9925 7 44.2625 7 32.88C7 18.0346 19.0346 6 33.88 6Z"
          fill="${markerFill}" />
      </g>
      <text x="34" y="38" text-anchor="middle" font-size="18" fill="${textFill}" font-family="'Merriweather Sans', sans-serif">
        ${cluster?.establishment_count}
      </text>
      <defs>
        <style type="text/css">
          <![CDATA[
            @import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0,300..800;1,300..800&display=swap');
          ]]>
        </style>
        <filter id="filter0_f_21370_62911" x="24.8828" y="66" width="18" height="9" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21370_62911" />
        </filter>
        <filter id="filter1_d_21370_62911" x="0.6" y="0.88" width="66.5617" height="76.8" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1.28" />
          <feGaussianBlur stdDeviation="3.2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_21370_62911" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_21370_62911" result="shape" />
        </filter>
      </defs>
    </svg>
  `

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
}
